import {
  addDestinationCardPaymentMethod,
  tokenizeDestinationCard,
} from "../services/api";
import { brandFromPan, last4 as last4Of } from "./card-brand";
import type { PayoutInput } from "../interfaces/payout";

export interface PayoutCardSaved {
  source: "saved";
  paymentMethodId: string;
  brand: string;
  last4: string;
  cardExpiry: string;
  cardholderName?: string;
}

export const registerPayoutCard = async (
  linkId: string,
  payout: PayoutInput,
  cardholderName?: string
): Promise<PayoutCardSaved> => {
  const [expiryMonth, expiryYearShort] = (payout.cardExpiry ?? "").split("/");
  const expiryYear = expiryYearShort ? `20${expiryYearShort}` : "";

  const holder =
    cardholderName?.trim() || payout.cardholderName?.trim() || undefined;

  let numberToken = payout.numberToken;
  let last4 = payout.last4 ?? "";
  let brand = (payout.brand || "OTHER").toUpperCase();

  if (!numberToken) {
    const cleanedPan = (payout.cardPan ?? "").replace(/\D/g, "");
    if (cleanedPan.length < 13) {
      throw new Error("PAYOUT_CARD_MISSING_TOKEN");
    }
    brand = brandFromPan(cleanedPan);
    last4 = last4Of(cleanedPan);

    const tokenized = await tokenizeDestinationCard(cleanedPan);
    numberToken = tokenized.numberToken;
  }

  const registered = await addDestinationCardPaymentMethod(linkId, {
    tokenizedCardNumber: numberToken,
    last4,
    brand,
    expiryMonth,
    expiryYear,
    cardholderName: holder,
    validationId: payout.cvsValidationId || undefined,
  });

  return {
    source: "saved",
    paymentMethodId: registered.paymentMethodId,
    brand: registered.brand || brand,
    last4: registered.last4 || last4,
    cardExpiry: payout.cardExpiry ?? "",
    cardholderName: registered.cardholderName || holder,
  };
};
